/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListTeamMemberAvailabilityRequest} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'
import {ListTeamMemberAvailabilityResponse} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'


export const listTeamMemberAvailability = (request: ListTeamMemberAvailabilityRequest, options?: CashRequestOptions) => post<ListTeamMemberAvailabilityRequest, ListTeamMemberAvailabilityResponse>("/2.0/cash/list-team-member-availability", request, {...options, rejectOnError: true })